import { TextField } from '@mui/material';
import React from 'react';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import { valueByName } from './form_utils';

export const ECTextField = props => {
  const { name, label, form, defaultValue, initial, ...rest } = props;

  let dv = valueByName(initial, name);
  if (dv === undefined || dv === null) {
    dv = defaultValue;
  }
  if (dv === undefined || dv === null) {
    dv = '';
  }

  return (
    <Controller
      control={form.control}
      name={name}
      defaultValue={dv}
      render={({ field, fieldState }) => (
        <TextField
          {...field}
          label={label}
          fullWidth
          margin='dense'
          variant='outlined'
          helperText={fieldState.error?.message}
          error={!!fieldState.error}
          {...rest}
        />
      )}
    />
  );
};

ECTextField.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  form: PropTypes.object,
  defaultValue: PropTypes.any,
  initial: PropTypes.object,
};
